import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CacheValuesPipe } from './cache-values.pipe';
import { FormatDatePipe } from './date-format.pipe';

@NgModule({
  declarations: [CacheValuesPipe, FormatDatePipe],
  imports: [CommonModule],
  exports: [CacheValuesPipe, FormatDatePipe],
})
export class PipeModule {}
